import { cardStyle, chipStyle, badgeStyle, topicLabel } from './tokens';

/**
 * DiscussionCard — one row of the community feed.
 * Shared by CommunityHome, TopicScreen and AllDiscussionsScreen so the
 * card visuals stay identical across every entry point.
 */
export default function DiscussionCard({ q, sharedCount = 0, onOpen }) {
  return (
    <button
      onClick={onOpen}
      data-testid={`community-question-${q.id}`}
      style={{
        ...cardStyle,
        padding: '18px 18px 16px',
        textAlign: 'left',
        border: '1px solid rgba(0,0,0,.04)',
        cursor: 'pointer',
        width: '100%',
        fontFamily: 'inherit',
      }}
    >
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 10 }}>
        <span style={chipStyle}>{topicLabel(q.topic)}</span>
        <span style={{ fontSize: 11.5, color: '#8A847C' }}>· {q.when}</span>
      </div>
      <div style={{ fontSize: 16, fontWeight: 600, color: '#232323', lineHeight: 1.35, marginBottom: 6 }}>
        {q.title}
      </div>
      {q.description && (
        <p style={{ margin: '0 0 14px', fontSize: 13, lineHeight: 1.55, color: '#6F6A66' }}>
          {previewOf(q.description)}
        </p>
      )}
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        gap: 10, flexWrap: 'wrap',
        marginTop: q.description ? 0 : 12,
      }}>
        <span style={{ fontSize: 12, color: '#8A847C' }}>
          {q.author} · {formatSharedCount(sharedCount)}
        </span>
        <span style={badgeStyle}>Understanding</span>
      </div>
    </button>
  );
}

export function previewOf(text = '') {
  const t = String(text).replace(/\s+/g, ' ').trim();
  return t.length > 140 ? t.slice(0, 137) + '…' : t;
}

export function formatSharedCount(n) {
  if (n === 0) return 'No shared experiences yet';
  if (n === 1) return '1 shared experience';
  return `${n} shared experiences`;
}
